import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing burgers and cola
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <FastFoodIcon width={12} />
 */
const FastFoodIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M4,40H28v2a1.84,1.84,0,0,1-1.61,2H5.61A1.84,1.84,0,0,1,4,
            42Zm0-8H28C28,21.3,4,21.3,4,32Zm0,6H28V34H4ZM43.89,10.56A1,1,
            0,0,0,43,10H34V4.82A.83.83,0,0,0,33.17,4H30.83a.83.83,0,0,
            0-.83.83V10H21a1,1,0,0,0-.89.57A.89.89,0,0,0,20,11v2a1,1,0,0,
            0,.74.95L22,20.74C28.1,22.37,32,26.54,32,32V42h6l5.26-28.05A1,
            1,0,0,0,44,13V11A.89.89,0,0,0,43.89,10.56Z`}
        />
    </SvgIcon>
)

FastFoodIcon.defaultProps = defaultProps

export { FastFoodIcon }
